// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronDown48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronDown48: FC<ChevronDown48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M38.4 20.686 24 32.48 9.6 20.686l2.416-2.972L24 27.518l11.984-9.804 2.416 2.972Z" />
        </svg>
    );
};

export default ChevronDown48;
